import type { FC } from 'react';
import { Radio, RadioGroup } from '@ordr-as/umami-react/radio';
import type { CourseDto } from '../../../../../../../generated-api';

interface Props {
  courses: CourseDto[];
  selectedCourseId?: string;
  onChange: (courseId: string | undefined) => void;
}

const NO_COURSE = 'No course';

const CoursePicker: FC<Props> = ({ courses, selectedCourseId, onChange }) => {
  const handleChange = (value: string) => {
    onChange(value === NO_COURSE ? undefined : value);
  };

  return (
    <RadioGroup
      className="flex flex-col gap-4"
      value={selectedCourseId ?? NO_COURSE}
      aria-label="Change course"
      onChange={handleChange}
    >
      <Radio className="h-7" value={NO_COURSE}>
        No course
      </Radio>
      <>
        {courses.map((course) => (
          <Radio className="h-7" key={course.courseId} aria-label={course.name} value={course.courseId}>
            {course.name}
          </Radio>
        ))}
      </>
    </RadioGroup>
  );
};

export default CoursePicker;
